import React, { Component } from 'react'
import { browserHistory } from 'utils/navigation'
import { Container, SortableTable, Loader, Button, Popup, Divider } from 'components/UIElements'
import { STATUS_OPTIONS } from 'utils/constants'
import handleComponentStateLoading from 'utils/handleComponentStateLoading'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'
import '../stylesheets/participant.scss'
import UpdateStatusSection from '../../../../VisitSchedules/routes/VisitSchedulesPage/components/UpdateStatusSection'
import ViewVisitInstrumentsSection from '../../../../VisitSchedules/routes/VisitSchedulesPage/components/ViewVisitInstrumentsSection'

const headerOptions = [
  { key: 'visitName', sortable: true, component: 'Visit Name' },
  { key: 'scheduledDate', sortable: true, component: 'Scheduled Date' },
  { key: 'actualDate', sortable: true, component: 'Actual Date' },
  { key: 'status', sortable: true, component: 'Status' },
  { key: 'action', component: 'Actions', className: 'text-align-center' },
]

class ParticipantVisits extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isUpdateStatusRowExpanded: {},
      isInstrumentsRowExpanded: {},
    }
  }

  componentDidMount() {
    this.onFetchPtpVisits()
  }

  onFetchPtpVisits = () => {
    const { fetchParticipantVisits, ptpId, studyID } = this.props
    if (ptpId)
      handleComponentStateLoading.call(
        this,
        fetchParticipantVisits.bind(this, studyID, ptpId),
        'participantVisitsLoading',
      )
  }

  isVisitIrtControlled = (visitId, participantVisitMetadata, studyScheduleVisitId) => {
    const { isIrtControlledVisit } = this.props
    return (
      typeof isIrtControlledVisit === 'function' &&
      isIrtControlledVisit(visitId, participantVisitMetadata, studyScheduleVisitId)
    )
  }

  renderActionsCell = ({ idx, row, className, isUpdateAllowed }) => {
    const { canViewVisitSchedule, disabled, isSiteCoord, isSponsor, ptpId, studyID, studyVersionID } = this.props
    const { visitId, studyScheduleVisitId, participantVisitMetadata } = row[0]
    const status = row.filter(rowData => rowData.key === 'status').map(ptpIDObj => ptpIDObj.value)?.[0]

    const isIrtControlled = this.isVisitIrtControlled(visitId, participantVisitMetadata, studyScheduleVisitId)
    const showReschedule = !isIrtControlled && status !== STATUS_OPTIONS.Confirmed
    const showUpdateStatus = !isIrtControlled && isUpdateAllowed
    const hasMenuActions = showReschedule || showUpdateStatus || true

    const canSeeMenu = isSiteCoord || isSponsor
    return canSeeMenu ? (
      <td key={`col_${idx}`} className={className}>
        {canViewVisitSchedule && hasMenuActions ? (
          <div className='flexed center-justified'>
            <Popup
              dark
              noPointer={false}
              position='bottom'
              className='edit actions-popup'
              disabled={disabled}
              trigger={<Button link icon='fas fa-pencil-alt' />}>
              <>
                {showReschedule && (
                  <Button
                    className='close-trigger'
                    content={STRINGS.visitScheduleReschedule}
                    onClick={() => {
                      browserHistory.push(
                        `/studies/${studyID}/${studyVersionID}/visit-schedules/participant-visit/${ptpId}-${visitId}/edit`,
                      )
                    }}
                  />
                )}
                {showUpdateStatus && (
                  <Button
                    className='close-trigger'
                    content={STRINGS.visitScheduleUpdateStatus}
                    onClick={() => {
                      this.setState({
                        isUpdateStatusRowExpanded: {
                          ...this.state.isUpdateStatusRowExpanded,
                          [visitId]: true,
                        },
                        isInstrumentsRowExpanded: {
                          ...this.state.isInstrumentsRowExpanded,
                          [visitId]: false,
                        },
                      })
                    }}
                  />
                )}
                <Button
                  className='close-trigger view-instruments-btn'
                  content={STRINGS.visitScheduleViewInstruments}
                  onClick={() => this.onViewVisitInstruments(visitId, studyScheduleVisitId)}
                />
              </>
            </Popup>
          </div>
        ) : null}
      </td>
    ) : null
  }

  renderStatusCell = ({ idx, value, className }) => {
    return (
      <td key={`col_${idx}`} className={className}>
        {value !== STATUS_OPTIONS.Passed ? <div className={`visit-status-cell ${value}`}>{value}</div> : null}
      </td>
    )
  }

  getHeaderOptions = () => {
    const { isSiteCoord, isSponsor } = this.props
    if (!(isSiteCoord || isSponsor)) {
      return headerOptions.slice(0, -1)
    }
    return headerOptions
  }

  expandedRow = row => {
    const { ptpId, studyID, updatePreviousScheduleVisit, requireMissedVisitReason, isCollectConfirmedTime } = this.props
    const { visitId, studyScheduleVisitId, participantVisitMetadata } = row[0]
    if (this.isVisitIrtControlled(visitId, participantVisitMetadata, studyScheduleVisitId)) {
      return null
    }
    const scheduledDate = row.filter(el => el.key === 'scheduledDate')[0]
    const isScheduleDateFuture = new Date(scheduledDate.value) > new Date()
    const status = row.filter(rowData => rowData.key === 'status').map(ptpIDObj => ptpIDObj.value)?.[0]
    const statusReasonValue = row
      .filter(rowData => rowData.key === 'status')
      .map(ptpIDObj => ptpIDObj.statusReasonValue)?.[0]
    const actualDateTime = row.find(({ key, sortValue }) => key === 'actualDate' && !isNaN(sortValue))
    const actualDate = actualDateTime?.value
    const actualTime = actualDateTime?.sortValue
    return (
      <UpdateStatusSection
        status={status}
        updatePreviousScheduleVisit={updatePreviousScheduleVisit}
        onClose={() => {
          this.setState({
            isUpdateStatusRowExpanded: {
              ...this.state.isUpdateStatusRowExpanded,
              [visitId]: false,
            },
            isInstrumentsRowExpanded: {
              ...this.state.isInstrumentsRowExpanded,
              [visitId]: false,
            },
          })
        }}
        studyID={studyID}
        ssvId={visitId}
        ptpID={ptpId}
        heading={isScheduleDateFuture ? STRINGS.visitHappenning : STRINGS.didVisitHappen}
        scheduledDate={scheduledDate}
        isScheduleDateFuture={isScheduleDateFuture}
        requireMissedVisitReason={requireMissedVisitReason}
        statusReasonValue={statusReasonValue}
        actualDate={actualDate}
        isCollectConfirmedTime={isCollectConfirmedTime}
        actualTime={actualTime}
      />
    )
  }

  render() {
    const { participantVisits, visitInstrumentsByVisitId, visitInstrumentsLoadingByVisitId } = this.props
    const { participantVisitsLoading, isUpdateStatusRowExpanded } = this.state
    const renderFunctions = {
      action: this.renderActionsCell,
      status: this.renderStatusCell,
    }
    return (
      <Container centered flex column>
        <div className='title'>Visits</div>
        <div>
          {participantVisitsLoading ? (
            <Loader inContainer size={25} />
          ) : (
            <div>
              <SortableTable
                id='participant-visits-table'
                className='participant-visits-table'
                headerOptions={this.getHeaderOptions()}
                rowList={participantVisits}
                renderFunctions={renderFunctions}
                viewMoreWithTablePages={{ minRows: 10, maxRows: 10 }}
                emptyText='No Matching Participant Visits'
                sortingBy='scheduledDate'
                initialOrder='ascending'
                rowExpandOptions={{
                  isRowExpanded: row => {
                    const { visitId, studyScheduleVisitId, participantVisitMetadata } = row[0]
                    if (this.isVisitIrtControlled(visitId, participantVisitMetadata, studyScheduleVisitId)) {
                      return !!this.state.isInstrumentsRowExpanded[visitId]
                    }
                    // Expand if Update Status is open OR the instruments view is open
                    return !!isUpdateStatusRowExpanded[visitId] || !!this.state.isInstrumentsRowExpanded[visitId]
                  },
                  expandedRowClassName: 'expanded-row',
                }}
                expandedRow={row => {
                  const { visitId, studyScheduleVisitId, participantVisitMetadata } = row[0]
                  const instrumentsPayload = visitInstrumentsByVisitId?.[visitId]
                  const isLoading = visitInstrumentsLoadingByVisitId?.[visitId]
                  const { isUpdateStatusRowExpanded, isInstrumentsRowExpanded } = this.state
                  const isIrtControlled = this.isVisitIrtControlled(
                    visitId,
                    participantVisitMetadata,
                    studyScheduleVisitId,
                  )

                  return (
                    <div>
                      {!isIrtControlled &&
                        isUpdateStatusRowExpanded?.[visitId] &&
                        !isInstrumentsRowExpanded?.[visitId] &&
                        this.expandedRow(row)}
                      {!isUpdateStatusRowExpanded?.[visitId] && isInstrumentsRowExpanded?.[visitId] ? (
                        <ViewVisitInstrumentsSection
                          visitId={visitId}
                          instrumentsPayload={instrumentsPayload}
                          isLoading={isLoading}
                          getInstrumentStatusText={inst => this.getInstrumentStatusText(inst, instrumentsPayload)}
                          onClose={() => {
                            this.setState({
                              isInstrumentsRowExpanded: {
                                ...this.state.isInstrumentsRowExpanded,
                                [visitId]: false,
                              },
                            })
                          }}
                        />
                      ) : null}
                    </div>
                  )
                }}
              />
            </div>
          )}
        </div>
      </Container>
    )
  }

  onViewVisitInstruments = (visitId, studyScheduleVisitId) => {
    const { fetchVisitInstruments, studyID, ptpId } = this.props
    // Fetch with URL id but store under UI's visitId key
    fetchVisitInstruments(studyID, ptpId, studyScheduleVisitId, visitId)
    this.setState({
      isInstrumentsRowExpanded: {
        ...this.state.isInstrumentsRowExpanded,
        [visitId]: true,
      },
      // Ensure Update Status is closed when opening instruments
      isUpdateStatusRowExpanded: {
        ...this.state.isUpdateStatusRowExpanded,
        [visitId]: false,
      },
    })
  }

  getInstrumentStatusText = (inst, visitPayload) => {
    const { instance_completion, instance_start_date } = inst || {}
    const status = instance_completion
    const startDate = inst?.instance_start_date || instance_start_date

    const visitConfirmed = !!(
      visitPayload?.confirmed_datetime ||
      visitPayload?.[inst?.instrument_schedule?.chain_deployment_info?.visit_id]?.confirmed_datetime
    )

    const fmt = dateStr =>
      dateStr
        ? new Date(dateStr).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })
        : ''

    if (status?.expired_date) return `Expired on ${fmt(status.expired_date)}`
    if (status?.completed_date) return `Completed on ${fmt(status.completed_date)}`
    if (startDate && new Date(startDate) <= new Date()) return `Available since ${fmt(startDate)}`
    if (inst?.instrument_deploy_on_confirm === true && !visitConfirmed) return 'Unavailable until visit is confirmed'
    if (startDate && new Date(startDate) > new Date()) return `Unavailable until ${fmt(startDate)}`
    return 'Unavailable until visit is confirmed'
  }
}

ParticipantVisits.propTypes = {
  canViewVisitSchedule: PropTypes.bool,
  disabled: PropTypes.bool,
  fetchParticipantVisits: PropTypes.func,
  isSiteCoord: PropTypes.bool,
  participantVisits: PropTypes.arrayOf(PropTypes.array),
  ptpId: PropTypes.number,
  studyID: PropTypes.number,
}

export default ParticipantVisits
